import Loader from "components/common/loader";
import UserListWrapper from "routes/analysis/users/components/userListWrapper";
import { FC } from "react";
import { useParams } from "react-router-dom";
import { ListType } from "routes/analysis/types/analysis";
import { useAtomValue } from "jotai";
import { filterAtom } from "jotai/store";
import { FetchAnalysisData } from "routes/analysis/queries/analysis";
import { FetchUserList } from "./queries/users";


const UsersInline: FC<{ type: ListType, typeId: string }> = ({ typeId, type }) => {
  const { analysisId } = useParams();

  const userFilter = useAtomValue(filterAtom);

  const { data, isPending } = FetchUserList(analysisId, type, typeId, userFilter);
  const {data: analysisData} = FetchAnalysisData(analysisId);

  return(
    isPending || !data || !analysisData
      ? <Loader inline loadingType="circular"/>
      : <UserListWrapper analysisData={analysisData} userList={data} showMatch={false} inline/>
    )
}

export default UsersInline;